import { FormControl, FormLabel, MenuItem, Select, Stack } from '@mui/material';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React from 'react';

const ManualSelectShppingCart = ({
  selectedCartGuid,
  setSelectedCartGuid,
  emptyError,
  loading,
  availableShppingCartList,
}) => {
  return (
    <Stack
      alignItems="start"
      justifyContent="center"
      gap={1}
      py={3}
      sx={{
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <FormLabel>شناسه‌ی سبد</FormLabel>
      <FormControl
        variant="standard"
        sx={{ width: '100%', paddingRight: 3 }}
        error={!selectedCartGuid && emptyError}
      >
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={selectedCartGuid}
          onChange={e => setSelectedCartGuid(e.target.value)}
        >
          {loading ? (
            <SpinnerLoader />
          ) : (
            (availableShppingCartList ?? []).map(type => (
              <MenuItem
                value={type.key}
                key={type.key}
                sx={{ direction: 'rtl' }}
              >
                {type.value}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default ManualSelectShppingCart;
